<template>
    <div id="old-catalog-filter" :class="{ open: showMobileFilters }">

        <div id="catalog-filter-overlay"
             class="hidden-xs-up text-yanone"
             :class="{show: showMobileFilters || showMobileSort}"
             @click="showMobileFilters = false; showMobileSort = false;"></div>

        <div id="catalog-filter-toolbar" class="hidden-xs-up text-yanone flex-grid text-center text-uppercase"
             :class="{busy: loading}">
            <div class="flex-xs-6 px-0 py-0" @click="showMobileSort = !showMobileSort">
                <span>
                    <i class="icon-cr icon-sort"
                       :class="{ accent: selected.sort }"></i>
                    <span>{{sortLabel}}</span>
                </span>
            </div>
            <div class="flex-xs-6 px-0 py-0" @click="showMobileFilters = true">
                <span>
                    <i class="icon-cr icon-filter"></i>
                    Filtrar
                </span>
            </div>
        </div>

        <ul id="catalog-filter-sort" class="hidden-xs-up text-yanone" v-show="!loading"
            :class="{ show: showMobileSort }">
            <li>Ordenar:</li>
            <li v-for="option of sortOptions"
                :class="{'text-bold': option.value === selected.sort}"
                @click="handleSort($event, option)">
                {{option.label}}
            </li>
        </ul>

        <div id="catalog-filter-header" class="hidden-xs-up text-yanone" @click="showMobileFilters = false">
            <div class="section-header">
                <h2 class="my">
                    <i class="icon-cr icon-chevron-left"></i>
                    Filtros
                </h2>
                <div class="ml-auto px">
                    <div class="cr-spinner-small" v-show="loading"></div>
                </div>
            </div>
            <hr class="mx-0 my-0"/>
        </div>

        <div id="catalog-filter-current" v-if="displaySelected" class="hidden-xs-down text-yanone">
            <div id="catalog-filter-current-header">
                <span>Seleção atual</span>
                <a :href="mainUrl" @click="fetch(false, $event)" class="text-accent text-underline">Limpar</a>
            </div>
            <ul>
                <li v-if="selected.type_id && selected.type_id < 500">
                    {{ selected.type_name }}
                    <a :href="url('tipo', selected.type_id, selected.type_url, true)" @click="fetch(false, $event)">
                        <i class="icon-cr icon-cr-hover icon-close"></i>
                    </a>
                </li>
                <li v-if="selected.gender">
                    {{ selected.gender_name }}
                    <a :href="url('genero', selected.gender, selected.gender_url, true)"
                       @click="fetch(false, $event)">
                        <i class="icon-cr icon-cr-hover icon-close"></i>
                    </a>
                </li>
                <li v-if="selected.category">
                    {{ selected.category_name }}
                    <a :href="url('categoria', selected.category, selected.category_url, true)"
                       @click="fetch(false, $event)">
                        <i class="icon-cr icon-cr-hover icon-close"></i>
                    </a>
                </li>
                <li v-if="selected.color">
                    {{ selected.color_name }}
                    <a :href="url('cor', selected.color, selected.color_url, true)" @click="fetch(false, $event)">
                        <i class="icon-cr icon-cr-hover icon-close"></i>
                    </a>
                </li>
                <li v-if="selected.size">
                    Tamanho: {{ selected.size }}
                    <a :href="url('tamanho', selected.size, selected.size, true)" @click="fetch(false, $event)">
                        <i class="icon-cr icon-cr-hover icon-close"></i>
                    </a>
                </li>
                <li v-if="selected.price">
                    <span>
                        <template v-if="!selected.price_min">Até&nbsp;</template>
                        <template v-if="selected.price_min && selected.price_max">De</template>
                        <template v-if="!selected.price_max">Acima de</template>
                        <template
                            v-if="selected.price_min"><strong>{{ selected.price_min | formatMoney }}</strong></template>
                        <template v-if="selected.price_max"><template
                            v-if="selected.price_min">até&nbsp;</template> <strong>{{ selected.price_max | formatMoney }}</strong></template>
                    </span>
                    <a :href="url('preco', selected.price, selected.price, true)" @click="fetch(false, $event)">
                        <i class="icon-cr icon-cr-hover icon-close"></i>
                    </a>
                </li>
            </ul>
        </div>

        <h2 :class="{'mt-0': !displaySelected}">
            Filtros
        </h2>

        <div class="frame text-yanone" v-if="noFiltersToDisplay">
            Nenhum filtro disponível.
        </div>

        <div id="catalog-filter-body" class="text-yanone">
            <div id="catalog-filter-content" :class="{busy: loading}">
                <div class="catalog-filter-section" v-if="!$scope.IS_REGULAR_CUSTOMER">
                    <div class="section-header">
                        <h3 class="section-title">Tipo de produção</h3>
                    </div>
                    <ul class="catalog-filter-list">
                        <li v-for="stock in filters.stock_filter" class="mb">
                            <a :href="url('inPhysicalStock',stock.id,null, false)"
                               @click="fetch(true, $event)">
                                <input type="radio" class="cr-radio" :checked="selected.inPhysicalStock == stock.id"
                                       v-bind:id="'filter-stock-' + stock.id"/>
                                <label v-bind:for="'filter-stock-' + stock.id">{{ stock.name }}</label>
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="catalog-filter-section" v-if="displayFilterTypes">
                    <div class="section-header">
                        <h3 class="section-title">Tipo</h3>
                        <a class="text-accent text-uppercase"
                           v-if="selected.type_id && selected.type_id < 500"
                           :href="url('tipo', selected.type_id, selected.type_url, true)"
                           @click="fetch(false, $event)">
                            Limpar
                        </a>
                    </div>
                    <ul class="catalog-filter-list">
                        <li v-for="type in filters.types" :class="{ 'selected': selected.type_id == type.id }"
                            class="mb">
                            <a :href="url('tipo', type.id, type.url, selected.type_id == type.id)"
                               @click="fetch(false, $event)">
                                <input type="radio" class="cr-radio" :checked="selected.type_id == type.id"
                                       v-bind:id="'filter-type-' + type.id"/>
                                <label v-bind:for="'filter-type-' + type.id">{{ type.name }}</label>
                            </a>
                            <div class="badge-default">{{type.count}}</div>
                        </li>
                    </ul>
                </div>

                <div class="catalog-filter-section" v-if="displayFilterGenders">
                    <div class="section-header">
                        <h3 class="section-title">Gênero</h3>
                        <a class="text-accent text-uppercase"
                           v-if="selected.gender"
                           :href="url('genero', selected.gender, selected.gender_url, true)"
                           @click="fetch(false, $event)">
                            Limpar
                        </a>
                    </div>
                    <ul class="catalog-filter-list">
                        <li v-for="gender in filters.genders" :class="{ 'selected': selected.gender == gender.id }"
                            v-if="gender.count > 0" class="mb">
                            <a :href="url('genero', gender.id, gender.url, selected.gender == gender.id)"
                               @click="fetch(false, $event)">
                                <input type="radio" class="cr-radio" :checked="selected.gender == gender.id"
                                       v-bind:id="'filter-gender-' + gender.id"/>
                                <label v-bind:for="'filter-gender-' + gender.id">{{ gender.name }}</label>
                            </a>
                        </li>
                    </ul>
                </div>

                <div class="catalog-filter-section"
                     v-if="displayFilterSizesAdult || displayFilterSizesChild || displayFilterSizes">
                    <div class="section-header">
                        <h3 class="section-title">Tamanho</h3>
                        <a class="text-accent text-uppercase"
                           v-if="selected.size"
                           @click="removeFilterSize($event)">
                            Limpar
                        </a>
                    </div>

                    <template v-if="displayFilterSizesAdult">
                        <h4>Adulto</h4>
                        <ul id="catalog-filter-sizes" class="d-flex flex-wrap">
                            <li v-for="size in filters.sizes_adult" v-if="size.count > 0">
                                <input type="radio"
                                       :id="`mobile-filter-size-a-${size.name}`"
                                       name="mobile-filter-size"
                                       :checked="selected.size == size.name"
                                       @change="filterSize(size, $event)">
                                <label :for="`mobile-filter-size-a-${size.name}`">{{ size.name }}</label>
                            </li>
                        </ul>
                    </template>

                    <template v-if="displayFilterSizesChild">
                        <h4>Infantil</h4>
                        <ul id="catalog-filter-child-sizes" class="d-flex flex-wrap">
                            <li v-for="size in filters.sizes_child" v-if="size.count > 0">
                                <input type="radio"
                                       :id="`mobile-filter-child-size-a-${size.name}`"
                                       name="mobile-filter-child-size"
                                       :checked="selected.size == size.name"
                                       @change="filterSize(size, $event)">
                                <label :for="`mobile-filter-child-size-a-${size.name}`">{{ size.name }}</label>
                            </li>
                        </ul>
                    </template>

                    <template v-if="$scope.IS_REGULAR_CUSTOMER">
                        <div class="mt">
                            <span @click="filterDeliveryReady($event)">
                                <input type="checkbox" class="cr-checkbox"
                                       v-model="deliveryReadySelected"
                                       :id="'filter-stock-' + deliveryReadyFilter.id">
                                <label class="d-inline-block" :for="'filter-stock-' + deliveryReadyFilter.id">{{deliveryReadyFilter.name}}</label>
                            </span>
                            <span @click="showDeliveryReadyInfo = true" style="text-decoration: none">
                                <i class="cursor-pointer icon-cr icon-question-sign"></i>
                            </span>
                        </div>

                        <div v-show="showDeliveryReadyWarning" class="mt">
                            <hr/>
                            Selecione um tamanho
                        </div>
                    </template>
                </div>

                <div class="catalog-filter-section" v-if="displayFilterColors">
                    <div class="section-header">
                        <h3 class="section-title">Cor</h3>
                        <a class="text-accent text-uppercase"
                           v-if="selected.color"
                           :href="url('cor', selected.color, selected.color_url, true)"
                           @click="fetch(false, $event)">
                            Limpar
                        </a>
                    </div>
                    <ul id="catalog-filter-colors"
                        class="d-flex flex-wrap"
                        v-if="!multipleFabricsSelected"
                        @mouseleave="selectedColor = null">
                        <li v-for="color in filters.colors"
                            v-if="color.id && color.id != 14"
                            @mouseenter="selectedColor = color.name">
                            <input type="radio"
                                   :id="`mobile-filter-color-${color.id}`"
                                   name="mobile-filter-color"
                                   :checked="selected.color == color.id"
                                   @change="fetch(false, $event, url('cor', color.id, color.url, selected.color == color.id))">
                            <label :for="`mobile-filter-color-${color.id}`"
                                   :style="{ 'background-color': '#' + color.rgb }">
                            </label>
                        </li>
                    </ul>
                    <p v-if="selectedColor || (selected || {}).color_name">
                        <strong>{{ selectedColor || selected.color_name }}</strong>
                    </p>
                    <div :class="{'mt' : ! multipleFabricsSelected}">
                        <a @click="filterMultipleFabrics($event)">
                            <input type="checkbox" class="cr-checkbox"
                                   v-model="multipleFabricsSelected"
                                   id="filter-multiple-fabrics">
                            <label for="filter-multiple-fabrics">Disponíveis em Várias Cores</label>
                        </a>
                    </div>
                </div>

                <div class="catalog-filter-section" v-if="displayFilterPrices">
                    <div class="section-header">
                        <h3 class="section-title">Preço</h3>
                        <a class="text-accent text-uppercase"
                           v-if="selected.price"
                           :href="url('preco', selected.price, selected.price, true)"
                           @click="fetch(false, $event)">
                            Limpar
                        </a>
                    </div>
                    <ul class="catalog-filter-list">
                        <li v-for="price in filters.prices" class="mb"
                            :class="{ 'selected': selected.price == price.id }" v-if="price.count > 0">
                            <a :href="url('preco', price.id, price.id, selected.price == price.id)"
                               @click="fetch(true, $event)">
                                <input type="radio" class="cr-radio" :checked="selected.price == price.id"
                                       v-bind:id="'filter-price-' + price.id"/>
                                <label v-bind:for="'filter-price-' + price.id">
                                    <span v-if="!price.min">Até&nbsp;</span>
                                    <span v-if="price.min && price.max">De</span>
                                    <span v-if="!price.max">Acima de</span>
                                    <span v-if="price.min" style="white-space: nowrap"><strong>{{ price.min | formatMoney }}</strong></span>
                                    <span v-if="price.max" style="white-space: nowrap"><span
                                        v-if="price.min">até&nbsp;</span> <strong>{{ price.max | formatMoney }}</strong></span>
                                </label>
                            </a>
                            <div class="badge-default">{{ price.count }}</div>
                        </li>
                    </ul>
                </div>

                <div class="catalog-filter-section" v-if="displayFilterCategories">
                    <div class="section-header">
                        <h3 class="section-title">{{hasCollections ? 'Categoria' : 'Tema'}}</h3>
                        <a class="text-accent text-uppercase"
                           v-if="selected.category"
                           :href="url('categoria', selected.category, selected.category_url, true)"
                           @click="fetch(false, $event)">
                            Limpar
                        </a>
                    </div>

                    <template v-if="hasCollections">
                        <h5 class="section-title">Coleções Exclusivas</h5>
                        <ul class="catalog-filter-list">
                            <li v-if="collection.count > 0 " class="mb" v-for="(collection, index) in filters.collections"
                                :class="{ 'selected': selected.category == collection.id }">
                                <a :href="url('categoria', collection.id, collection.url, selected.category == collection.id)"
                                   @click="fetch(true, $event)">
                                    <input type="radio" class="cr-radio" :checked="selected.category == collection.id"
                                           v-bind:id="'filter-category-' + collection.id"/>
                                    <label v-bind:for="'filter-category-' + collection.id">{{ collection.name }}</label>
                                </a>
                                <div class="badge-default">{{collection.count}}</div>
                            </li>
                        </ul>
                    </template>

                    <template v-if="hasCategories">
                        <h5 class="section-title" v-if="hasCollections">Temas</h5>
                        <ul class="catalog-filter-list">
                            <li v-if="category.count > 0 " class="mb" v-for="(category, index) in filters.categories"
                                :class="{ 'selected': selected.category == category.id, 'hidden-xs-down': index > 5 && !displayAllFilterCategories }">
                                <a :href="url('categoria', category.id, category.url, selected.category == category.id)"
                                   @click="fetch(true, $event)">
                                    <input type="radio" class="cr-radio" :checked="selected.category == category.id"
                                           v-bind:id="'filter-category-' + category.id"/>
                                    <label v-bind:for="'filter-category-' + category.id">{{ category.name }}</label>
                                </a>
                                <div class="badge-default">{{category.count}}</div>
                            </li>
                        </ul>
                        <div style="padding: .5rem 0 .5rem 2rem" class="hidden-xs-up"
                             v-if="!displayAllFilterCategories && filters.categories.length > 6">
                            <a class="text-accent" @click="displayAllFilterCategories = true">Ver todos os temas...</a>
                        </div>
                    </template>
                </div>
            </div>
        </div>

        <DeliverReadyInfoModal v-model="showDeliveryReadyInfo"/>
    </div>
</template>

<script>
    import {readUrlQuery} from "../../../common/common";
    import CatalogFetch from "./CatalogFetch";
    import DeliverReadyInfoModal from "../product/DeliverReadyInfoModal";
    import {catalogStore} from "../../common/store/catalog-store";

    export default {
        name: "OldCatalogFilters",

        components: {DeliverReadyInfoModal},

        mixins: [CatalogFetch],

        data() {
            const stockQuery = readUrlQuery('inPhysicalStock');
            const fabricsQuery = readUrlQuery('multipleFabrics');

            return {
                storeState: catalogStore.state,
                sortOptions: [
                    {label: 'Padrão', value: null},
                    {label: 'Menor preço', value: 'menor-preco'},
                    {label: 'Maior preço', value: 'maior-preco'},
                    {label: 'Lançamentos', value: 'lancamentos'},
                ],
                showMobileSort: false,
                showMobileFilters: false,
                displayAllFilterCategories: false,
                deliveryReadySelected: stockQuery && stockQuery == 1,
                multipleFabricsSelected: fabricsQuery && fabricsQuery == 1,
                showDeliveryReadyInfo: false,
                selectedColor: null
            };
        },

        watch: {
            selected() {
                if (this.deliveryReadyFilter) {
                    this.deliveryReadySelected = this.deliveryReadySelected || this.selected.inPhysicalStock == this.deliveryReadyFilter.id;
                }
            }
        },

        computed: {
            filters() {
                return this.storeState.filters;
            },

            meta() {
                return this.storeState.meta;
            },

            selected() {
                return this.storeState.selected;
            },

            loading() {
                return this.storeState.loading;
            },

            sortLabel() {
                if (this.selected.sort) {
                    if (this.selected.sort === 'menor-preco') {
                        return 'Menor preço';
                    } else if (this.selected.sort === 'maior-preco') {
                        return 'Maior preço';
                    } else if (this.selected.sort === 'lancamentos') {
                        return 'Lançamentos';
                    }
                }

                return 'Ordenar';
            },

            mainUrl() {
                if (this.selected.chico_chic) return '/' + this.selected.category_url + '/';

                let url = this.selected.type_main_url ? this.selected.type_main_url : 'loja';

                if (this.selected.pretty_url) {
                    return ('/' + url + '/');
                }

                return window.location.pathname.replace(/[\/]+$/, "") + (this.selected.query ? '?query=' + this.selected.query : '');
            },

            displaySelected() {
                return this.selected.type_id < 500 || this.selected.gender || this.selected.category || this.selected.color || this.selected.size || this.selected.price;
            },

            noFiltersToDisplay() {
                return !this.displayFilterTypes
                    && !this.displayFilterGenders
                    && !this.displayFilterSizesAdult
                    && !this.displayFilterSizesChild
                    && !this.displayFilterSizes
                    && !this.displayFilterColors
                    && !this.displayFilterCategories
                    && !this.displayFilterPrices;
            },

            displayFilterTypes() {
                return this.filters.types && this.filters.types.length > 0 && !this.selected.chico_chic;
            },

            displayFilterGenders() {
                if (!this.filters.genders)
                    return false;

                let total = this.filters.genders.reduce((sum, item) => sum + item.count, 0);
                return total > 0;
            },

            displayFilterSizesAdult() {
                return this.filters.sizes_adult && this.filters.sizes_adult.length > 0;
            },

            displayFilterSizesChild() {
                return this.filters.sizes_child && this.filters.sizes_child.length > 0;
            },

            displayFilterSizes() {
                return this.filters.sizes && this.filters.sizes.length > 0 && !this.selected.chico_chic;
            },

            displayFilterColors() {
                return this.filters.colors && this.filters.colors.length > 0 && !this.selected.chico_chic;
            },

            hasCategories(){
                return !(!this.filters || !this.filters.categories || this.filters.categories.length === 0);
            },

            hasCollections(){
                return !(!this.filters || !this.filters.collections || this.filters.collections.length === 0);
            },

            displayFilterCategories() {
                if (! this.hasCategories && ! this.hasCollections) return false;

                // Não exibe se estiver filtrando produtos de parceiros
                if ((this.selected || {}).partner) return false;

                // Não exibe para o hotsite de Support Jufas Bar
                if (this.meta && (this.meta.canonical || '').indexOf('/support-jufas-bar') !== -1) return false;

                // Exibe o filtro de categoria se a categoria selecionada não for a de promoção
                return !(this.selected || {}).category || (this.selected || {}).category != 285;
            },

            displayFilterPrices() {
                return this.filters.prices && this.filters.prices.filter(price => price.count > 0).length > 0;
            },

            deliveryReadyFilter() {
                return this.filters && this.filters.stock_filter ? this.filters.stock_filter.find(f => f.id === 1) : null;
            },

            showDeliveryReadyWarning() {
                return this.deliveryReadySelected && !this.selected.size;
            }
        },

        methods: {
            handleSort($event, option) {
                this.showMobileSort = false;
                this.fetch(true, $event, this.sort(option.value), false)
            },

            filterSize(size, event) {
                let url = this.url('tamanho', size.name, size.name, this.selected.size == size.name);

                if (this.$scope.IS_REGULAR_CUSTOMER) {
                    if (this.selected.size == size.name && this.deliveryReadyFilter.id == this.selected.inPhysicalStock) {
                        url = this.url('inPhysicalStock', null, null, true, url);
                        this.deliveryReadySelected = false;
                    }

                    if (this.selected.size != size.name && this.deliveryReadySelected) {
                        url = this.url('inPhysicalStock', this.deliveryReadyFilter.id, null, false, url);
                    }
                }

                this.fetch(true, event, url);
            },

            removeFilterSize(event) {
                let url = this.url('tamanho', null, null, true);

                if (this.$scope.IS_REGULAR_CUSTOMER && this.deliveryReadyFilter.id == this.selected.inPhysicalStock) {
                    url = this.url('inPhysicalStock', null, null, true, url);
                    this.deliveryReadySelected = false;
                }

                this.fetch(true, event, url);
            },

            filterDeliveryReady(event) {
                event.stopPropagation();
                event.preventDefault();
                this.deliveryReadySelected = !this.deliveryReadySelected;

                if (this.selected.size) {
                    let url = this.url('inPhysicalStock', this.deliveryReadyFilter.id, null, this.selected.inPhysicalStock == this.deliveryReadyFilter.id);
                    this.fetch(true, event, url);
                }
            },

            filterMultipleFabrics(event) {
                event.stopPropagation();
                event.preventDefault();
                this.multipleFabricsSelected = !this.multipleFabricsSelected;

                let url = this.url('multipleFabrics', this.multipleFabricsSelected ? 1 : 0, null, !this.multipleFabricsSelected);
                url = this.url('cor', null, null, true, url);
                this.fetch(true, event, url);
            },
        }
    }
</script>